import React, { Component } from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title, ChartOptions, PluginOptionsByType } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import { useAppDispatch } from '../../app/hooks';
import consumerService from '../../services/consumer.service';

function ConsumptionOverview(props: any) {  

  ChartJS.register(ArcElement, Tooltip, Legend, Title,);

  const datapoints = [props.greenEnerge, props.energyLoad];
  const text = [props.text];
  // const datapoints = [50, 25];
console.log(datapoints)
  // Plugin to show dounut chart middle text
  const counter = {
    id:"counter",
    beforeDraw(chart: any, args: any, option: any) {
      const{ ctx, chartArea: {top, right, bottom, left, width, height} } = chart;
      ctx.save();

      //Calculate Green energey precentage;
      // let sum = datapoints[0] + datapoints[1];
      // let percentage = (datapoints[0] * 100 / sum).toFixed(2)+"%";
      
      ctx.font = "700 1.75rem Montserrat";
      ctx.textAlign = "center"
      let sum = parseFloat(datapoints[0]) + parseFloat(datapoints[1]);
			let percentage = (parseFloat(datapoints[0]) * 100 / sum).toFixed(2) + "%" == "100.00%" ? "100%" : (parseFloat(datapoints[0]) * 100 / sum).toFixed(2) + "%";

      ctx.fillText((sum == 0 ? "0%" : percentage), width / 2, top + 10 + ( height / 2 ));
      ctx.font = "0.675rem Montserrat";
      ctx.textAlign = "center"
      
      ctx.fillText(text, width / 2, top + 22 + ( height / 2 ));
    }
  }
  const chartDataDoughnut = {
    labels: ['Green attributes (kWh) ', 'Unfilled Load (kWh) '],
    backgroundColor: '#f5f5f5',
    datasets: [
      {
        label: '# of Votes',
        
        data: datapoints,
        backgroundColor: [
          '#006837',
          '#E16839',
        ],
        borderColor: [
          '#006837',
          '#E16839',
        ],
        borderWidth: 1,
        borderRadius: 0,
      },
    ]
  };

  const chartOptionsDoughnut: ChartOptions<'doughnut'> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
        position: 'right',
        labels: {
          usePointStyle: true,
          padding: 20,
          textAlign: 'left',
          font: {
            size: 16,
            family: 'Montserrat',
          }
        },
      },
    }

  };

  return (
    <div>
      <div className='chartWrapper'>
      <Doughnut data={chartDataDoughnut} options={chartOptionsDoughnut} plugins={[counter]} className="consumptionOverview" />
      {/* <span className='chartMiddleText'>100%</span> */}
      </div>
    </div>
  )

}
export default ConsumptionOverview;